<template>

    <div :id="'stream-' + streamId"></div>

</template>

<script>

    import Clappr from 'clappr';


	export default {
		name: 'Video-Page-Test',
		data () {
			return {
				player: null,
            }
        },
        props: [
            'streamId',
            'watermark'
        ],
        watch: {
            streamId: function() {
                if(this.player !== null) {
                    var _this = this
                    this.player.configure({
                        source: "https://edge-media.livestormchasing.com/hls/" + _this.streamId + "/index.m3u8",
                        autoPlay: true,
                    });
                }
            }
        },
		mounted() {
            var self = this
            setTimeout(function() {
                self.initVid();
            }, 200);
		},
		methods: {
            initVid() {
                var _this = this
                var playerElement = document.getElementById('stream-' + _this.streamId)

                this.player = new Clappr.Player({
                    source: "https://edge-media.livestormchasing.com/hls/" + _this.streamId + "/index.m3u8",
                    autoPlay: true,
                    width: "100%",
                    height: "100%",
                    mute: true,
                    chromeless: true,
                    watermark: require('@/assets/live_storm_media_logo_edit.png'),
                })

                this.player.attachTo(playerElement)
            }
        },
        destroyed() {
            this.player.destroy();
        },

	}
</script>

<style>
	#videoHolder {
		width: 100%;
		height: 100%;
	}

    .video {
        width: 100%;
        height: 100%;
    }
    
    .clappr-watermark {
        position: absolute !important;
        min-width: 70px !important;
        max-width: 250px !important;
        width: 23% !important;
        text-align: center !important;
        z-index: 10 !important;
    }

    [data-watermark-bottom-right] {
        bottom: 20px !important;
        right: 37px !important;
    }

</style>
